import type { DSR_MESSAGE_TYPES, DsrMessagePayloads } from './types.dsr'
import { usePostRobot } from '@lib/sdk/utils/postrobot'
import * as envDsr from './env.dsr'
import * as loadingDsr from './loading.dsr'
import * as filesDsr from './files.dsr'

/**
 * Subscribe to a given event type by its key.
 *
 * @param type The event type/key to subscribe to.
 * @param handler The handler function to call when the event is emitted.
 * @returns A Promise resolving to a cleanup function to unsubscribe from the event.
 */
async function on(
  type: (typeof DSR_MESSAGE_TYPES)[keyof typeof DSR_MESSAGE_TYPES],
  handler: (data: DsrMessagePayloads[typeof type]) => Promise<void>,
) {
  const pr = await usePostRobot()
  const listener = pr.on(type, (e) => handler(e.data))

  // return the cleanup function
  return listener.cancel
}

export default {
  on,
  ...envDsr,
  ...loadingDsr,
  ...filesDsr,
}
